import HeroCTA from '../components/HeroCTA'
import './TestimonialsPage.css'

interface Testimonial {
  id: number
  name: string
  title: string
  company: string
  text: string
  rating: number
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: 'Jason Balderston',
    title: 'Facilities and Operations Manager',
    company: 'Oregon State University',
    text: 'I\'ve worked with Laboratory Specialists for nearly 20 years and they are always my first call.    Many of my projects are quite small but they always approach them with the same enthusiasm and commitment to great service as the larger projects.   Because they offer turnkey solutions and I get to work with the same people from design through installation, I can save time and gain a certain peace of mind knowing that the person I begin the project with will be there in the end and be accountable.', 
    rating: 5
  },
  {
    id: 2,
    name: 'Leanne Tollerud',
    title: 'Project Manager',
    company: 'Advance Cabinet Designs, Inc.',
    text: 'I\'ve worked with Laboratory Specialists for over 30 years on both large and small projects.  The customer service has always been excellent.  Quick turn around on shop drawings.  Great follow thru all the way to the end of the project.  I would highly recommend to anyone looking for Epoxy tops or laboratory equipment.',
    rating: 5
  },

]

function TestimonialsPage() {
  return (
    <div className="testimonials-page">
      <section className="page-hero">
        <div className="container">
          <h1>Client Testimonials</h1>
          <p className="page-hero-subtitle">
            Hear from our satisfied clients about their experience working with Laboratory Specialists. 
            We're proud to have helped businesses and universities create exactly the lab they need.
          </p>
        </div>
      </section>

      <section className="testimonials-content">
        <div className="container">
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-rating">
                  {'★'.repeat(testimonial.rating)}
                </div>
                <blockquote className="testimonial-text">
                  "{testimonial.text}"
                </blockquote>
                <div className="testimonial-author">
                  <div className="testimonial-author-info">
                    <div className="testimonial-author-name">{testimonial.name}</div>
                    <div className="testimonial-author-title">
                      {testimonial.title}, {testimonial.company}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="testimonials-cta-section">
        <div className="container">
          <div className="testimonials-cta-content">
            <h2>Ready to Experience Our Service?</h2>
            <p>
              Join our satisfied clients and let us help you create exactly the lab you need. 
              Our team brings extensive parts knowledge and service expertise to every project.
            </p>
            <HeroCTA />
          </div>
        </div>
      </section>
    </div>
  )
}

export default TestimonialsPage
